import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { useTransientProcessingJobs } from "../hooks/useTransientProcessingJobs";
import { TransientJobDetailsModal } from "./TransientJobDetailsModal";
import { TransientRequestHistoryTable } from "./TransientRequestHistoryTable";
import { TransientRequestModal } from "./TransientRequestModal";

export const TransientResponsePanel = () => {
  const { t } = useTranslation();
  const [requestModalOpen, setRequestModalOpen] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState<null | string>(null);
  const { jobs } = useTransientProcessingJobs();
  const selectedJob = useMemo(
    () => jobs.find((job) => job.job_id === selectedJobId) ?? null,
    [jobs, selectedJobId]
  );

  return (
    <Stack className="w-full flex-col">
      <div className="w-full rounded-ds-0-75x bg-lds-surface-bright p-6 border-ds-subtle">
        <div className="mb-4 flex w-full items-center justify-end">
          <Button onClick={() => setRequestModalOpen(true)} size="md" startIconName="Add" variant="primary">
            {t("Execution.transient.newRequest")}
          </Button>
        </div>
        <TransientRequestHistoryTable onJobSelect={(job) => setSelectedJobId(job.job_id)} />
      </div>
      <TransientRequestModal
        onJobStarted={(job) => setSelectedJobId(job.job_id)}
        open={requestModalOpen}
        setOpen={setRequestModalOpen}
      />
      <TransientJobDetailsModal job={selectedJob} onClose={() => setSelectedJobId(null)} />
    </Stack>
  );
};
